'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initFakeStore = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _ScreenReducer = require('../components/screen/ScreenReducer');

var _ScreenReducer2 = _interopRequireDefault(_ScreenReducer);

var _ModuleReducer = require('../components/module/ModuleReducer');

var _DialogReducer = require('../components/dialog/DialogReducer');

var _MaskReducer = require('../components/mask/MaskReducer');

var _UiReducer = require('../components/ui/UiReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fakeStore = void 0;
var dispatches = [];

var initFakeStore = exports.initFakeStore = function initFakeStore(state) {
  var enableDispatching = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


  if (state && !state.screen) {
    state.screen = _ScreenReducer.initialState;
  }

  if (state && !state.module) {
    state.module = _ModuleReducer.initialState;
  }

  dispatches = [];

  fakeStore = {
    default: function _default() {},
    subscribe: function subscribe() {},
    dispatch: function dispatch(func) {
      dispatches.push(func);
      if (enableDispatching) {
        state.screen = (0, _ScreenReducer2.default)(state.screen, func);
      }
    },
    runSaga: function runSaga(func) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      func.apply(undefined, args);
    },
    getState: function getState() {
      return (0, _assign2.default)({}, state);
    },
    clearDispatches: function clearDispatches() {
      dispatches = [];
    },
    getDispatches: function getDispatches() {
      return dispatches;
    }
  };
};

var getFakeStore = function getFakeStore() {
  if (!fakeStore) {
    initFakeStore({ ui: _UiReducer.initialState, module: _ModuleReducer.initialState, dialog: _DialogReducer.initialState, mask: _MaskReducer.initialState, screen: _ScreenReducer.initialState });
  }

  return fakeStore;
};

exports.default = getFakeStore;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/mocks/FakeStore.js
// module id = 805
// module chunks = 10